<template>
  <div class="home">

    <v-parallax src="https://img.huffingtonpost.com/asset/564283401400006f023ca734.jpeg?cache=hB0msYX0Bh&ops=1910_1000" max-height="900">
    
      <v-layout align-center column justify-center fill-height>
       
        <v-flex xs12>
          <v-img :src="Logo" mt-3 max-height="300" contain> </v-img>
          <v-layout column justify-center align-center>
            <span class="display-2 font-weight-heavy mt-3">ProjecTraffic</span>
            <span class="display-1 font-weight-light mt-2 text-xs-center">Traffic Reporting Made Easy</span>       
          </v-layout>   
        </v-flex>
        
      </v-layout>
    
    </v-parallax>

    <v-container align-baseline fluid class="teal lighten-2">

        <v-layout column align-center justify-center class="white--text py-4" height="100%">

            <v-flex class="py-3" md6 xs12>
                <h1 class="display-2 text-xs-center">Get A Visual Tour of Hawaiian Traffic</h1>
            </v-flex>

            <v-flex>

              <v-layout row wrap justify-center align-center>

                <v-flex xs12 md4 lg3 v-for="camera in ranCamArray" :key="camera.Name">
                  <v-card flat class="text-xs-center ma-4">
                    
                    <v-responsive class="pt-0">
                      <v-img :src="camera.HalfImageURL" :aspect-ratio="16/9" width="400px"></v-img>
                    </v-responsive>

                    <v-card-text>
                      <div class="subheading">{{camera.Name}}</div>
                    </v-card-text>

                  </v-card>
                </v-flex>

              </v-layout>

            </v-flex>

        </v-layout>

        <v-divider></v-divider>
        
        <v-layout row wrap justify-start class="py-4">

          <v-flex xs12 md6>
            <v-img :src="ForumPic" height="500" contain></v-img>
          </v-flex>

          <v-flex xs12 md6>

            <v-layout column align-center>
              
              <v-flex xs12>
                <h1 class="display-2 text-xs-center mb-3">Discuss About the Traffic</h1>
              </v-flex>

              <v-flex xs12>
                <p class="text-xs-center font-weight-light headline"> Wonder what happened on the H1 this morning that caused you to be late at work? Or think that the H3 freeway into Kaneohe has too much debris? Come and discuss each individual report on the forums page!</p>
              </v-flex>

              <v-flex xs12>
                <v-btn large class="green lighten-3 white--text" @click="runChange('Forums-Page')">
                  <v-icon left>message</v-icon>
                  <span>Go to Forums</span>
                </v-btn>
              </v-flex>

            </v-layout>

          </v-flex>

        </v-layout>

    </v-container>

  </div>
</template>

<script>
import Logo from '@/assets/logo.png';
import ForumPic from '@/assets/home_talk.png'
import {bus} from '@/main.js'
const cammy = require('@/assets/cameras/rootCamera.json');
export default {
  name: 'HomePage',
  data() {
    return {
      ranCamArray: this.randomCams(),
      Logo: Logo,
      ForumPic: ForumPic
    }
  },
  methods: {
    randomCams: function() {
      let temp = [];
      for(var i=0; i < 3; i++) {
        temp.push(cammy.Camera[Math.round(Math.random() * 12)]);
      }
      return temp;
    },
    runChange(toWhat) {
        bus.$emit("forumChange",toWhat);
    }

  }
}
</script>